import { useEffect, useState } from "react";

const sizes = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};

function getZoom() {
  return ((window.outerWidth - 10) / window.innerWidth) * 100;
}

function getIsSmallScreen() {
  return window.innerWidth <= 767;
}

const useBreakpoint = () => {
  const [state, setState] = useState(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const zoom = getZoom();
    const isSmallScreen = getIsSmallScreen();
    let breakpoint = "xxl";
    switch (true) {
      case width < sizes.sm:
        breakpoint = "xs";
        break;
      case width < sizes.md:
        breakpoint = "sm";
        break;
      case width < sizes.lg:
        breakpoint = "md";
        break;
      case width < sizes.xl:
        breakpoint = "lg";
        break;
      case width < sizes.xxl:
        breakpoint = "xl";
        break;
      case width >= sizes.xxl:
        breakpoint = "xxl";
        break;
      default:
        break;
    }
    return { breakpoint, width, height, zoom, isSmallScreen };
  });

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const zoom = getZoom();
      const isSmallScreen = getIsSmallScreen();
      let breakpoint = "xxl";
      switch (true) {
        case width < sizes.sm:
          breakpoint = "xs";
          break;
        case width < sizes.md:
          breakpoint = "sm";
          break;
        case width < sizes.lg:
          breakpoint = "md";
          break;
        case width < sizes.xl:
          breakpoint = "lg";
          break;
        case width < sizes.xxl:
          breakpoint = "xl";
          break;
        case width >= sizes.xxl:
          breakpoint = "xxl";
          break;
        default:
          break;
      }
      setState({ breakpoint, width, height, zoom, isSmallScreen });
    };
    updateSize();
    window.addEventListener("load", updateSize);
    window.addEventListener("resize", updateSize);
    return () => {
      window.removeEventListener("load", updateSize);
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  return state;
};

export default useBreakpoint;
